module.exports = __webpack_public_path__ + "791b0cf01c6b5c1e90f357356a0dcd92.svg";